import { Skeleton } from '@/components/ui/Skeleton';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card.tsx';
import React from 'react';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';

const BookingPendingSkeleton = () => {
  return (
    <div>
      <div className="absolute left-0 right-0 top-12 mx-auto hidden max-w-[1200px] px-4 lg:block">
        <span className="text-xs text-neutral-600">Organizator</span>
        <Skeleton className="h-[20px] w-[130px]" />
      </div>

      <div className="mx-auto mt-10 max-w-[600px] space-y-2 px-4 lg:mt-20">
        <div className="mb-6 space-y-1">
          <div className="mb-4 lg:hidden">
            <span className="text-xs text-neutral-600">Organizator</span>
            <Skeleton className="h-[20px] w-[130px]" />
          </div>
          <div className="mb-6 animate-pulse space-y-1">
            <Skeleton className="h-[32px] w-full max-w-[320px]" />
            <Skeleton className="h-[24px] w-full max-w-[200px]" />
          </div>
          <Card>
            <CardHeader>
              <CardTitle>
                <Skeleton className="h-[24px] w-[200px] animate-pulse" />
              </CardTitle>
            </CardHeader>
            <CardContent className="animate-pulse space-y-4 p-4">
              <div className="w-[60%] space-y-1">
                <Skeleton className="h-[14.5px] w-[120px]" />
                <Skeleton className="h-[34px] w-full" />
              </div>
              <TwoInputsRow>
                <div className="space-y-1">
                  <Skeleton className="h-[14.5px] w-[120px]" />
                  <Skeleton className="h-[34px] w-full" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-[14.5px] w-[120px]" />
                  <Skeleton className="h-[34px] w-full" />
                </div>
              </TwoInputsRow>
              <div className="space-y-1">
                <Skeleton className="h-[14.5px] w-[120px]" />
                <Skeleton className="h-[34px] w-full" />
              </div>
              <div className="space-y-1">
                <Skeleton className="h-[14.5px] w-[120px]" />
                <Skeleton className="h-[34px] w-full" />
              </div>
              <div className="space-y-1">
                <Skeleton className="h-[14.5px] w-[120px]" />
                <Skeleton className="h-[34px] w-full" />
              </div>
              <div className="space-y-1">
                <Skeleton className="h-[14.5px] w-[120px]" />
                <Skeleton className="h-[34px] w-full" />
              </div>
              <TwoInputsRow ratio="1/3">
                <div className="space-y-1">
                  <Skeleton className="h-[14.5px] w-[120px]" />
                  <Skeleton className="h-[34px] w-full" />
                </div>
                <div className="space-y-1">
                  <Skeleton className="h-[14.5px] w-[120px]" />
                  <Skeleton className="h-[34px] w-full" />
                </div>
              </TwoInputsRow>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default BookingPendingSkeleton;
